<template>
    <div class="navigation-wrapper">
        <div class="links-container">
            <h1>brands</h1>
            <h2>by springbig</h2>
            <ul>
              <li :key="index"
                  v-for="(list, index) in unorderedList"
                  @click="handleAnchorClick(list.refName, list.id)">
                  {{list.name}} <fai v-if="list.id === activeListId" :icon="['fas', 'caret-left']" />
              </li>
            </ul>
            <p class="refer-brand desktop" @click="openModal()">refer a brand</p>
        </div>

        <p class="refer-brand mobile" @click="openModal()">refer a brand</p>
        <simple-modal class="refer-brand-modal" title="refer a brand" v-if="showModal" @rejected="rejectedModal">
          <p class="sub-title">enter brand information in the fields below</p>
          <section class="refer-brand-wrapper">
            <label>brand name</label>
            <input
              name="brand_name"
              @blur="requiredField('brand_name', brandName)"
              type="text"
              :class="{ 'refer-brand-error' : emptyBrandName }"
              maxlength="100"
              v-model="brandName">
            <span class="danger" v-if="emptyBrandName">brand name required</span>
            <label>contact name</label>
            <input
              @blur="requiredField('contact_name', brandContactName)"
              name="contact_name"
              type="text"
              :class="{ 'refer-brand-error' : emptyBrandContactName }"
              maxlength="100"
              v-model="brandContactName">
            <span class="danger" v-if="emptyBrandContactName">contact name required</span>
            <label>phone number</label>
            <input
              :class="{ 'refer-brand-error' : !validPhoneNumber && brandPhoneNumber.length}"
              name="phone_number"
              type="tel"
              maxlength="10"
              @blur="validatePhoneNumber()"
              v-model="brandPhoneNumber">
            <label>email address</label>
            <input
              :class="{ 'refer-brand-error' : !validEmail && brandEmail.length }"
              name="email"
              type="email"
              @blur="validateEmail()"
              v-model="brandEmail">
            <p v-if="!contactInfo" class="error-message">phone number or email address required</p>
            <p v-if="!validEmail || !validPhoneNumber" class="error-message">{{errorMessage}}</p>
            <footer>
              <button class="sb-button" @click="resolvedModal()">done</button>
            </footer>
          </section>
        </simple-modal>
    </div>
</template>

<script>
import { SimpleModal, ErrorBanner, UnexpectedError } from '@springbig/sb-components'
import EmailValidator from 'email-validator'
import { brandsMarketplaceAPI } from "../../services/api/brandsMarketplace"

  export default {
    name: 'BrandsMarketplaceNavigation',

    props: {
      showStateNav: Boolean,
      showSponsoredNav: Boolean,
      showStoreNav: Boolean
    },

    components: {
      SimpleModal,
      ErrorBanner
    },

    data() {
      return {
        activeListId: null,
        brandEmail: '',
        brandPhoneNumber: '',
        brandName: '',
        emptyBrandContactName: null,
        emptyBrandName: null,
        contactInfo: true,
        brandContactName: '',
        showModal: false,
        validEmail: null,
        validPhoneNumber: null,
        unorderedList: [
          {
            name: 'brands by state',
            refName: 'top',
            id: 0
          },
          {
            name: 'previously sponsored',
            refName: 'sponsored',
            id: 1
          },
          {
            name: 'in-store brands',
            refName: 'inStore',
            id: 2
          }
        ]
      }
    },

    methods: {
      handleAnchorClick(ref, id) {
        this.activeListId = id
        this.$emit('scrollMeTo', ref)
      },

      async resolvedModal() {
        this.requiredField('brand_name', this.brandName)
        this.requiredField('contact_name', this.brandContactName)

        if (!this.brandPhoneNumber.length && !this.brandEmail.length) {
          this.contactInfo = false
        } else {
          this.contactInfo = true
        }

        try {
          this.$store.dispatch('DISMISSED_MODAL');
          this.$store.dispatch('DISMISS_ERRORS', { type: UnexpectedError })
          if ((this.brandName.length && this.brandContactName.length && this.contactInfo) && (this.validPhoneNumber || this.validEmail)) {
            const response = await brandsMarketplaceAPI.postBrandReferral({
              brand_name: this.brandName,
              contact_name: this.brandContactName,
              phone_number: this?.brandPhoneNumber,
              email: this?.brandEmail
            })

            if (response.status === 201) {
              this.showModal = false
              this.clearFields()
            }
          }
        } catch (error) {
          this.$store.dispatch('ADD_ERROR', new UnexpectedError('500'))
        }
      },

      clearFields() {
        this.brandName = ''
        this.brandContactName = ''
        this.brandPhoneNumber = ''
        this.brandEmail = ''
        this.emptyBrandContactName = null
        this.emptyBrandName = null
        this.validEmail = null
        this.validPhoneNumber = null
        this.contactInfo = true
      },

      requiredField(name, val) {
        if (name === 'contact_name' && !val.length) {
          this.emptyBrandContactName = true
        } else if (name === 'contact_name' && val.length) {
          this.emptyBrandContactName = false
        }

        if (name === 'brand_name' && !val.length) {
          this.emptyBrandName = true
        } else if (name === 'brand_name' && val.length) {
          this.emptyBrandName = false
        }
      },

      openModal() {
        this.showModal = true
      },

      rejectedModal() {
        this.clearFields()
        this.showModal = false
      },

      validateEmail() {
        if (this.brandEmail.length) {
          this.validEmail = EmailValidator.validate(this.brandEmail)

          if (this.validEmail) {
            this.contactInfo = true
          } else {
            this.validEmail = false
          }
        }
      },

      validatePhoneNumber() {
        if (this.brandPhoneNumber.length) {
          const regex = /^\d{10}$/
          this.validPhoneNumber = regex.test(this.brandPhoneNumber)

          if (this.validPhoneNumber) {
            this.contactInfo = true
          }
        } else {
          this.validPhoneNumber = false
        }
      }
    },

    computed: {
      errorMessage: function() {
        if (!this.validEmail && !this.validPhoneNumber && this.brandPhoneNumber.length && this.brandEmail.length) {
          return `invalid phone number and email address`
        } else if (!this.validPhoneNumber && this.brandPhoneNumber.length) {
          return `invalid phone number`
        } else if (!this.validEmail && this.brandEmail.length) {
          return `invalid email address`
        }
      }
    },

    mounted() {
      if (!this.showStateNav) {
        this.unorderedList = this.unorderedList.filter(x => x.id !== 0)
      }

      if (!this.showSponsoredNav) {
        this.unorderedList = this.unorderedList.filter(x => x.id !== 1)
      }

      if (!this.showStoreNav) {
        this.unorderedList = this.unorderedList.filter(x => x.id !== 2)
      }
    }
  }
</script>

<style scoped>
  .links-container {
    color: #128ff9;
  }

  .links-container h1 {
    font-family: 'AileronThin';
    font-size: 2.5em;
    margin-bottom: 0;
  }

  .links-container  h2 {
    font-size: 20px;
    font-family: 'AileronThin';
    position: relative;
    bottom: 10px;
  }

  .links-container  ul {
    list-style: none;
    margin: 60px 0 0 0;
    cursor: pointer;
    width: max-content;
  }

  .links-container li {
    font-size: inherit;
    font-family: 'AileronLight';
    position: relative;
  }

  .links-container svg {
    font-size: 24px;
    border: 0;
    position: absolute;
    right: -10px;
    top: 0;
  }

  .refer-brand {
    margin-top: 30px;
    font-weight: bolder;
    cursor: pointer;
  }

  .refer-brand-error {
    border: 1px solid red;
  }

  .error-message, .danger {
    color: red;
    text-align: center;
  }

  .refer-brand-modal >>> .sb-button {
    font-family: 'AileronThin';
    color: #FFFFFF;
  }

  .refer-brand-modal >>> .sb-reject {
    display: none;
  }

  .sub-title {
    position: relative;
    bottom: 35px;
    text-align: center;
    font-family: 'AileronThin';
  }

  .refer-brand-modal >>> .bg-white {
    width: 550px;
    padding: 20px 70px;
    box-shadow: none !important;
  }

  .refer-brand-modal >>> .text-3xl {
    margin-top: 15px;
    font-weight: 600;
    color: #4A4A4A;
  }

  .refer-brand-modal >>> h2 {
    font-family: 'AileronThin';
    font-weight: 600;
    color: #4A4A4A;
  }

  section.refer-brand-wrapper label {
    font-size: 19px;
  }

  .desktop {
    display: block;
  }

  .mobile {
    display: none;
  }

  @media only screen and (max-width: 900px) {
    .desktop {
      display: none;
    }

    .mobile {
      display: inline-block;
      font-weight: bolder;
      cursor: pointer;
      color: #128ff9;
      font-size: 20px;
      position: relative;
      top: 50px;
      left: 18px;
    }

    .sub-title {
      font-size: 1.2rem;
    }

    .error-banner {
      color: red;
    }

    .refer-brand-modal >>> .bg-white {
      background-color: white;
      margin: 0;
      max-width: none;
      max-height: none;
      height: 100%;
      overflow: auto;
      padding: 20px;
      position: relative;
      border-radius: 0;
      border: 0;
      width: 100%;
    }
  }
</style>
